import React,{useState,useRef} from 'react';
import { Header ,Modal} from '../../../../../components';
import { Button, message, Input, BackTop } from 'antd';
import { useStateContext } from '../../../../../contexts/ContextProvider';
import { useModal } from 'react-modal-hook';
import  Table  from '../components/Table';
import  Form  from '../components/Form';
import { useFetchCustomfieldCase,UseFetchCreateCaseCustomfield,UseFetchUpdateCaseCustomfield,UseFetchDeleteCaseCustomfield,UseFetchListCaseCustomfield} from "../hooks/useFetch";

function CustomfieldCase() {
  const { currentColor } = useStateContext();
  const [ dataEdit, setDataEdit] = useState(null);
  const companyId = sessionStorage.getItem('activeCompanyId')
  const { data:dataCustomfieldCase, isLoading:isLoadingCustomfieldCase ,refetch:refetchCustomfieldCase } = useFetchCustomfieldCase(companyId);
  const {  mutate: fetchUpdateCaseCustomfield } = UseFetchUpdateCaseCustomfield();
  const {  mutate: fetchCreateCaseCustomfield } = UseFetchCreateCaseCustomfield();
  const {  mutate: deleteCaseCustomfield } = UseFetchDeleteCaseCustomfield();

  const titlePage = 'Case Customfield Setting';
  const formAddRef = useRef(null); 
  const formEditRef = useRef(null); 
  
  //#region usehook model
  const [showAddModal, hideAddModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formAddRef.current.validateFields();
        const payload = {
          ...value,
          required: value.required || false,
          companyId: sessionStorage.getItem('activeCompanyId')
        }
        await fetchCreateCaseCustomfield(payload)
        await message.destroy(); 
        await message.success('เพิ่มข้อมูลสำเร็จ');
        await hideAddModal();
        refetchCustomfieldCase()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถเพิ่มข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        await message.destroy(); 
        
      }
    };

    return (
      <Modal
        title={`เพิ่ม ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideAddModal}
      >
        <Form formRef={formAddRef}/>
      </Modal>
    );
  }, []);

  const [showEditModal, hideEditModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formEditRef.current.validateFields();
        const payload = {
          ...value,
          required: value.required || false,
          companyId: sessionStorage.getItem('activeCompanyId'),
          id: dataEdit.id
        }

        await fetchUpdateCaseCustomfield(payload)

        await message.destroy(); 
        await message.success('แก้ไขขอมูลสำเร็จ');
        await hideEditModal();
        refetchCustomfieldCase()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถแก้ไขข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        await message.destroy(); 
      }
    };

    return (
      <Modal
        title={`แก้ไข ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideEditModal}
      >
        <Form formRef={formEditRef} initialValues={dataEdit}/>
      </Modal>
    );
  }, [dataEdit,isLoadingCustomfieldCase]);
    //#endregion


  const handleEdit = (record) => {
     // Convert required to boolean for form
     const editRecord = {
       ...record,
       required: Boolean(record.required)
     };
     setDataEdit(editRecord);
     showEditModal()
  }

  const handleDelete = async (record) => {
    try {
      await deleteCaseCustomfield(record.id)
      await message.destroy(); 
      await message.success('ลบสำเร็จ',2);
      refetchCustomfieldCase()
    } catch (error) {
      message.error('ไม่สามารถลบได้'); 
    } finally {
      await message.destroy(); 
      await hideEditModal();
    }
  }

  return (
    <div className="md:m-10">
      <div className="flex justify-between">
        <Header category="App" title={titlePage} />
        <Button onClick={showAddModal} className='bg-blue-500 text-white'>
          เพิ่ม
        </Button>
      </div>
      <Table data={dataCustomfieldCase} onEdit={handleEdit} onDelete={handleDelete}  loading={isLoadingCustomfieldCase} dataBank={dataCustomfieldCase} bordered />
    </div>
  );
}

export default CustomfieldCase;
